module.exports = __webpack_public_path__ + "img/gender-female.08dac61.svg";